import type { DonationBatch } from '../types/marketPromotionP2.types';
import { DecisionTrailPanel, type DecisionStep } from './DecisionTrailPanel';

const BATCH_TRAIL_SKELETON_ROW_COUNT = 3;

function getBatchSteps(batch: DonationBatch): DecisionStep[] {
  return [
    {
      key: 'published',
      step: 'Published',
      isDone: batch.publishDate !== null,
      by: batch.publishedBy,
      at: batch.publishDate,
      comment: batch.publishComment,
    },
    {
      key: 'confirmed',
      step: 'Confirmed',
      isDone: batch.isConfirm === true,
      by: batch.confirmedBy,
      at: batch.confirmDate,
      comment: batch.salesComment,
    },
    {
      key: 'disbursed',
      step: 'Disbursed',
      isDone: batch.isDisburse,
      by: batch.disbursedBy,
      at: batch.disburseDate,
      comment: batch.accountsComment,
    },
  ];
}

interface DonationBatchTrailProps {
  batch: DonationBatch | undefined;
}

export function DonationBatchTrail({ batch }: DonationBatchTrailProps) {
  return (
    <DecisionTrailPanel
      title="Batch Logs"
      steps={batch ? getBatchSteps(batch) : undefined}
      skeletonRowCount={BATCH_TRAIL_SKELETON_ROW_COUNT}
    />
  );
}
